export default function GenericParameters() {
  return (
    <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 p-4 text-sm text-gray-600">
      This module does not yet have dedicated parameters.
    </div>
  );
}
